var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clas || ['d-flex', 'justify-center', 'align-center'],style:(_vm.customStyle)},[_c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"45px"}},[_vm._v("not_interested")]),_c('p',[_vm._v("No Data Yet")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }